import script from "./ImageCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=42d592d4&scoped=true&lang=css"

import exportComponent from "/home/sergio/Escritorio/VSCode/Rosepetal/0.5.x-sergio/rosepetal-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d592d4"]])

export default __exports__